import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "md:flex gap-2 md:gap-4 my-2 md:my-4 bg-[#1F1F1F] rounded-md p-2 md:p-4" }
const _hoisted_2 = { class: "mx-auto relative w-fit" }
const _hoisted_3 = { class: "bg-gray-700 rounded-md animate-pulse h-72 w-72 m-auto md:m-0" }
const _hoisted_4 = { class: "relative left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" }
const _hoisted_5 = { class: "w-full md:mt-0 mt-2 space-y-2" }
const _hoisted_6 = { class: "flex flex-start justify-between gap-2 md:gap-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-1/3 h-8 bg-gray-700 rounded-lg" }, null, -1)
const _hoisted_8 = { class: "flex gap-2 md:gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center h-7 md:w-28" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "animate-pulse w-16 h-5 bg-gray-700 rounded-lg" })
], -1)
const _hoisted_10 = { class: "flex flex-wrap gap-2" }

import { Divider } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DoujinViewSkeleton',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_spin, {
            tip: "Loading...",
            size: "large",
            class: "animate-pulse"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(3), (_, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(`animate-pulse w-8 h-8 bg-gray-700 rounded-lg ${!index && 'hidden md:block'}`)
            }, null, 2))
          }), 128))
        ])
      ]),
      _createVNode(_unref(Divider), { class: "bg-gray-600 my-0 md:!my-4" }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(6), (_, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "md:flex"
        }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(index === 4 ? 3 : 1), (value, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: _normalizeClass(`px-2 py-1 rounded-md bg-gray-700 h-7 ${index === 5 ? 'w-[132px]' : 'w-16'} animate-pulse`)
              }, _toDisplayString(value), 3))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})